import {Setting} from "./Setting";

export const organizationsSetting: Setting = {
    key: "Organization",
    title: "Организации",
    description: `Организации — это различные структуры или группы, которые объединяются для достижения общих целей. Эти организации могут быть как официальными, так и тайными, мирными или военными, и влиять на ход событий в игре. Они могут быть политическими, религиозными, экономическими, научными, преступными или культурными, и часто служат источником конфликтов, квестов или важных персонажей.`,
    components: [
        {
            title: "Политические и государственные организации",
            subComponents: [
                {
                    title: "Государства и империи",
                    description: `Правительства, которые управляют землями и народами. Это могут быть монархии, республики, диктатуры или другие формы правления.`,
                    examples: ["Королевство Элария, правящее средневековыми землями."]
                },
                {
                    title: "Партийные и политические движения",
                    description: `Группы, борющиеся за власть, реформы или права определённых слоёв населения. Эти организации могут быть как законными, так и революционными.`,
                    examples: ["Движение за свободу и равенство, борющееся против тирании."]
                },
                {
                    title: "Дипломатические альянсы",
                    description: `Международные организации, объединяющие страны или государства для достижения политических целей, защиты от угроз или ведения войны.`,
                    examples: ["Союз Семи Королевств, объединяющий силы против внешнего врага."]
                },
                {
                    title: "Герцогства, княжества и феодальные дома",
                    description: `Организации, возглавляемые аристократией, где власть распределяется между правителями отдельных территорий, но все они подчиняются центральной власти.`,
                    examples: ["Феодальный дом Грейвен, правящий провинцией на границе королевства."]
                }]
        },
        {
            title: "Религиозные организации",
            subComponents: [
                {
                    title: "Церкви и храмы",
                    description: `Религиозные институции, которые могут служить источниками моральных и духовных ориентиров, а также влиять на общественные и политические дела.`,
                    examples: ["Церковь Света, поклоняющаяся богине света и добра."]
                },
                {
                    title: "Религиозные культы",
                    description: `Тайные или экстремистские группы, часто поклоняющиеся одному богу, божеству или сверхъестественным силам, с жесткими учениями и практиками.`,
                    examples: ["Культ Черного Клинка, поклоняющийся демоническому богу разрушения."]
                },
                {
                    title: "Орден монастырей",
                    description: `Религиозные братства или общины, посвященные служению своему богу или божествам, иногда скрывающие тайные знания или артефакты.`,
                    examples: ["Орден Серебряного Лотоса, хранящий древние магические артефакты."]
                }]
        },
        {
            title: "Научные и образовательные организации",
            subComponents: [
                {
                    title: "Университеты и академии",
                    description: `Учебные заведения, где обучают магии, алхимии, инженерии, технике или философии. Они могут быть местами, где персонажи обучаются и раскрывают тайны мира.`,
                    examples: ["Академия магии, где учатся будущие колдуны и волшебники."]
                },
                {
                    title: "Научные общества и исследовательские институты",
                    description: `Организации, занимающиеся исследованиями, открытиями и продвижением новых технологий, знаний или магии.`,
                    examples: ["Общество алхимиков, исследующих свойства магических зелий."]
                },
                {
                    title: "Гильдии учёных или магов",
                    description: `Ассоциации магов, алхимиков или других исследователей, которые могут контролировать знания и исследования в своих областях.`,
                    examples: ["Гильдия инженеров, создающая новые технологии и изобретения."]
                }]
        },
        {
            title: "Экономические и торговые организации",
            subComponents: [
                {
                    title: "Торговые гильдии",
                    description: `Ассоциации предпринимателей и купцов, которые контролируют торговлю, устанавливают цены и регулируют конкуренцию на рынке.`,
                    examples: ["Гильдия купцов, торгующая редкими товарами и сокровищами."]
                },
                {
                    title: "Корпорации и финансовые группы",
                    description: `Крупные организации, занимающиеся производством товаров, услуг или инвестированием, с целью накопления богатства и власти.`,
                    examples: ["Корпорация Железный Дракон, доминирующая в производстве оружия и доспехов."]
                },
                {
                    title: "Карты и рынки",
                    description: `Торговые организации, которые занимаются обменом товаров и услуг между различными регионами или мирами.`,
                    examples: ["Караванная компания, перевозящая товары по опасным землям."]
                }, {
                    title: "Пиратские и контрабандистские группировки",
                    description: `Организации, занимающиеся незаконной торговлей, контрабандой, похищением и другими противозаконными действиями с целью получения прибыли.`,
                    examples: ["Пиратская братва, действующая на морских путях."]
                }]
        },
        {
            title: "Преступные и тайные организации",
            subComponents: [
                {
                    title: "Гильдии воров",
                    description: `Группы, занимающиеся кражами, шантажом, грабежами и другими преступными действиями, часто с тайными структурами и кодексами.`,
                    examples: ["Гильдия воров, действующая в тени и контролирующая подпольный рынок."]
                },
                {
                    title: "Наёмники и преступные банды",
                    description: `Организации, занимающиеся насилием и преступной деятельностью ради прибыли. Это могут быть банды, военные отряды или шайки.`,
                    examples: ["Банда головорезов, работающая на высшего биджолда."]
                },
                {
                    title: "Тайные общества",
                    description: `Группы, скрывающие свои истинные цели и деятельность от внешнего мира. Они могут преследовать свои секретные амбиции, контролируя события в мире через манипуляции.`,
                    examples: ["Тайное общество Чёрного Ордена, стремящееся к мировому господству"]
                },
                {
                    title: "Шпионские сети",
                    description: `Организации, занимающиеся шпионажем, разведкой и саботажем, часто работая на страну или корпорацию в условиях тайны и скрытности.`,
                    examples: ["Шпионская сеть, пытающаяся узнать секреты вражеской империи."]
                }]
        },
        {
            title: "Культурные и художественные организации",
            subComponents: [
                {
                    title: "Творческие союзы",
                    description: `Группы художников, музыкантов, писателей или других деятелей искусства, которые занимаются развитием культуры и поддержанием традиций.`,
                    examples: ["Театральная труппа, играющая классические пьесы."]
                },
                {
                    title: "Театры и культурные центры",
                    description: `Места, где проводятся культурные события, выставки, концерты и другие формы искусства, влияющие на общественные настроения.`,
                    examples: ["Королевский театр, где показываются великолепные спектакли."]
                },
                {
                    title: "Музеи и библиотеки",
                    description: `Организации, занимающиеся сохранением знаний, артефактов, истории и искусства, которые могут быть источником квестов или знаний.`,
                    examples: ["Музей древних артефактов, хранящий тайны прошлого."]
                }]
        },
        {
            title: "Военные и полицейские организации",
            subComponents: [
                {
                    title: "Армии и военные корпорации",
                    description: `Военные структуры, которые занимаются защитой, нападением или завоеванием. Это могут быть как национальные армии, так и частные вооружённые компании.`,
                    examples: ["Королевская гвардия, защищающая королевство от внешних угроз."]
                },
                {
                    title: "Полицейские силы",
                    description: `Организации, которые следят за правопорядком в обществе, расследуют преступления и поддерживают законы.`,
                    examples: ["Городская стража, борющаяся с преступностью в улицах."]
                },
                {
                    title: "Гвардии и охранные структуры",
                    description: `Группы, защищающие ключевые места, такие как дворцы, храмы или важные объекты от вторжений и нападений.`,
                    examples: ["Орден Серебряного Щита, защищающий священные святыни."]
                }]
        }

    ],
    prompt: {
        component: {
            list: 'Сгенерируй возможные организации из мира истории и опиши их',
            single: "Сгенерируй организацию из мира истории. Опиши ее цели, структуру, влияние на мир и персонажей.",
            extend: 'Дополни описание организации подробностями и разбей на абзацы. Чем занимаются в организации, структура организации, кто главный, какую роль она играет в мире. Перечисли основные свойства организации, которые могут повлиять на сюжет, мир и персонажей.'
        },
        element: {
            list: 'Сгенерируй возможные организации из мира истории и опиши их',
            single: "Сгенерируй организацию из мира истории. Опиши ее цели, структуру, влияние на мир и персонажей.",
            extend: 'Дополни описание организации подробностями и разбей на абзацы. Чем занимаются в организации, структура организации, кто главный, какую роль она играет в мире. Перечисли основные свойства организации, которые могут повлиять на сюжет, мир и персонажей.'
        },
        lore: {
            list: "Создай элементы лора на основе этой организации. Ее историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этой организации. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора организации и разбей на абзацы."
        }
    }
}